import { useEffect, useMemo, useState } from 'react';
import { message } from 'antd';
import { User, UserLevel } from 'types';
import API from '../../API';

interface Filters {
	search?: string;
	level?: UserLevel;
	showRemoved?: boolean;
}

export const useUsers = (filters: Filters) => {
	const [users, setUsers] = useState<User[]>();

	useEffect(() => {
		fetchUsers();
	}, []);

	const filtered = useMemo(() => {
		if (!users) {
			return undefined;
		}

		return users.filter((u) => {
			const search = filters.search?.trim().toLocaleLowerCase();
			if (search) {
				if (`${u.name} ${u.surname}`.toLocaleLowerCase().includes(search)) return true;

				return false;
			}

			if (filters.showRemoved === false && u.removed) {
				return false;
			}

			return true;
		});
	}, [filters, users]);

	const fetchUsers = async () => {
		try {
			const users = await API.users.getAll(true);

			setUsers(users);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	return filtered;
};
